import { SearchIcon, DentifierLogo, LogoutIcon } from "../../Icons/Icons";
import { TextField, IconButton } from "@mui/material";
import { logout } from "authorization/AuthorizationProvider";
import userHook from "hooks/userHook";

const Header = () => {
  const { userInformation } = userHook();

  const onLogout = () => {
    logout();
  };

  return (
    <div className="header-wrapper">
      <div className="header">
        <div className="logo">
          <DentifierLogo />
        </div>
        <div className="search">
          <TextField
            placeholder="Search"
            classes={{ root: "search-root" }}
            disabled
            InputProps={{
              startAdornment: <SearchIcon />,
            }}
          />
        </div>
        <div className="user-details">
          <span>Welcome, {userInformation?.name ?? 'Guest'}</span>
          <IconButton 
            className="mobile-logout"
            onClick={onLogout}
            title="Logout"
          >
            <LogoutIcon />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default Header;
